import { trueFalseDefaultOptions } from "./formDefinitionFunctions";
import * as stagesCase from "../../Stages/StagesCase";
import { ProductSpecificFormDefinition } from "../../../types/ProductService/ProductService";
import { VehicleContract } from "../../../types/Products/ContractLaw/VehicleContract";

const vehicleProductSpecificDefinition = (
  product: VehicleContract
): ReturnType<ProductSpecificFormDefinition<VehicleContract>> => [
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.buyerOrSeller`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => [{ value: "buyer" }, { value: "seller" }],
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.isNewVehicle`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => trueFalseDefaultOptions(`${product.productClassName}.isNewVehicle`),
  },
  {
    type: "ValidatorTextField",
    path: `${product.productClassName}.vehicleMake`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorTextField",
    path: `${product.productClassName}.model`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorTextField",
    path: `${product.productClassName}.vehicleId`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorNumberField",
    path: `${product.productClassName}.mileageAtPurchase`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorNumberField",
    path: `${product.productClassName}.currentMileage`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.expectedTotalMileage`,
    options: () => [{ value: "150000" }, { value: "200000" }, { value: "250000" }, { value: "300000" }],
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
  },
  {
    type: "ValidatorNumberField",
    path: `${product.productClassName}.purchasePrice`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    fieldType: "money",
    numberType: "float",
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.buyerPaidStatus`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => [{ value: "fully" }, { value: "partially" }],
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.locationOfGood`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => [{ value: "buyer" }, { value: "seller" }, { value: "elsewhere" }, { value: "unknown" }],
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.hasDefects`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => trueFalseDefaultOptions(`${product.productClassName}.hasDefects`),
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.isAccidentCar`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => trueFalseDefaultOptions(`${product.productClassName}.isAccidentCar`),
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.isThirdPartyFinanced`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    options: () => trueFalseDefaultOptions(`${product.productClassName}.isThirdPartyFinanced`),
  },
  {
    type: "ValidatorDateField",
    path: `${product.productClassName}.defectsRecognitionDate`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    isHidden: ({ product }) => product.hasDefects !== true,
  },
  {
    type: "ValidatorTextField",
    path: `${product.productClassName}.defectsDescriptionClient`,
    isDisabled: () => true,
    isHidden: ({ product }) => product.hasDefects !== true,
    additionalProps: {
      multiline: true,
      fullWidth: true,
    },
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.numberRepairAttempts`,
    options: () => [{ value: 0 }, { value: 1 }, { value: 2 }, { value: 3 }],
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    isHidden: ({ product }) => product.hasDefects !== true,
  },
  {
    type: "ValidatorSelect",
    path: `${product.productClassName}.numberReplacementAttempts`,
    options: () => [{ value: 0 }, { value: 1 }, { value: 2 }, { value: 3 }],
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    isHidden: ({ product }) => product.hasDefects !== true,
  },
];
export default vehicleProductSpecificDefinition;
